import React from 'react';
import { Row, Card, Progress, Col, Spin, Tooltip } from 'antd';
import {
  KPITitleText,
  KpiFlightDate,
  KpiSubText,
} from '../../../../../../shared/globalStyling/styledText';
import { SESSIONS_TOOLTIP } from '../../../../../../shared/constants/tooltips';
import moment from 'moment';
import { ArrowRightOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import {
  formatCurrency2SigFig,
  formatNumber2SigFig,
  formatWholeNumber,
} from '../../../../../../../core/utils/campaigns';
import { secondsToTimeText } from '../../../../utils/secondsToTimeText';

const DetailBar = ({
  startDate,
  endDate,
  sessionAttrPageViews,
  sessions,
  averageSessionDuration,
  pagesPerSession,
  loading = false,
  module = 'SESSIONS',
}) => {
  const styles = {
    container: {
      backgroundColor: '#fff',
      borderTop: 'solid 1px #e8e8e8',
      marginBottom: '1%',
    },
    secondaryContainer: {
      padding: '3% 3% 1% 3%',
      margin: 0,
    },
    title: {
      marginBottom: '10px',
    },
    keyColors: {
      spent: '#1665d8',
      remaining: '#34aa44',
      budget: '#030303',
      total: '#bec0c3',
      value: '#99999',
    },
    datesContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    dates: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
  };

  const getProgress = () => {
    const total = () => {
      var a = moment(startDate);
      var b = moment(endDate);
      const total = b.diff(a, 'days');
      return total;
    };

    const progress = () => {
      var a = moment();
      var b = moment(startDate);
      const progress = a.diff(b, 'days');
      return progress;
    };

    const totaldays = total();
    const progressDays = progress();

    if (progressDays <= 0) {
      return 100;
    }

    // % increase = Increase ÷ Original Number × 100.
    const daysleft = totaldays - progressDays;
    const daysin = totaldays - daysleft;
    const result = (daysin / totaldays) * 100;

    return Math.floor(result);
  };

  const currentposition = getProgress();

  return (
    <React.Fragment>
      <Spin spinning={loading}>
        <Row style={styles.container} wrap={false}>
          <Col xs={24}>
            <Row>
              <Col className="ant-col-md-flex-auto" xs={{ span: 24 }}>
                <Card
                  style={{ height: '10em', borderLeft: 0, borderTop: 0 }}
                  bodyStyle={{ borderLeft: 0 }}
                >
                  <div style={styles.title}>
                    <KPITitleText text={'Dates'} />
                  </div>
                  <div style={styles.datesContainer}>
                    <div style={styles.dates}>
                      <KpiFlightDate
                        text={
                          startDate
                            ? moment(startDate).format('MM/DD/YYYY')
                            : moment().format('MM/DD/YYYY')
                        }
                      />
                    </div>
                    <div>
                      <ArrowRightOutlined style={{ color: '#636363' }} />
                    </div>
                    <div style={styles.dates}>
                      <KpiFlightDate
                        text={
                          endDate
                            ? moment(endDate).format('MM/DD/YYYY')
                            : moment().format('MM/DD/YYYY')
                        }
                      />
                    </div>
                  </div>
                  <Progress
                    showInfo={false}
                    percent={currentposition}
                    status={currentposition !== 100 ? 'active' : 'normal'}
                    strokeColor={'#636363'}
                  />
                </Card>
              </Col>
              {module === 'SESSIONS' && (
                <>
                  <Col className="ant-col-md-flex-auto" xs={{ span: 24 }}>
                    <Card
                      style={{ height: '10em', borderLeft: 0, borderTop: 0 }}
                      bodyStyle={{ borderLeft: 0 }}
                    >
                      <div style={styles.title}>
                        <KPITitleText text={'Page Views'} />
                      </div>
                      <KpiSubText
                        text={sessionAttrPageViews ? formatWholeNumber(sessionAttrPageViews) : "N/A"}
                      />
                    </Card>
                  </Col>
                  <Col className="ant-col-md-flex-auto" xs={{ span: 24 }}>
                    <Card
                      style={{ height: '10em', borderLeft: 0, borderTop: 0 }}
                      bodyStyle={{ borderLeft: 0 }}
                    >
                      <div style={styles.title}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <KPITitleText text={'Sessions'} />
                          {SESSIONS_TOOLTIP && (
                            <Tooltip title={SESSIONS_TOOLTIP}>
                              <QuestionCircleOutlined/>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                      <KpiSubText text={sessions ? formatWholeNumber(sessions) : "N/A"} />
                    </Card>
                  </Col>
                  <Col className="ant-col-md-flex-auto" xs={{ span: 24 }}>
                    <Card
                      style={{ height: '10em', borderLeft: 0, borderTop: 0 }}
                      bodyStyle={{ borderLeft: 0 }}
                    >
                      <div style={styles.title}>
                        <KPITitleText text={'Avg. Session Duration'} />
                      </div>
                      <KpiSubText
                        text={averageSessionDuration ? secondsToTimeText(averageSessionDuration) : "N/A"}
                      />
                    </Card>
                  </Col>
                  <Col className="ant-col-md-flex-auto" xs={{ span: 24 }}>
                    <Card
                      style={{ height: '10em', borderLeft: 0, borderTop: 0 }}
                      bodyStyle={{ borderLeft: 0 }}
                    >
                      <div style={styles.title}>
                        <KPITitleText text={'Pages Per Session'} />
                      </div>
                      <KpiSubText
                        text={pagesPerSession ? formatNumber2SigFig(pagesPerSession) : "N/A"}
                      />
                    </Card>
                  </Col>
                </>
              )}
            </Row>
          </Col>
        </Row>
      </Spin>
    </React.Fragment>
  );
};

export default DetailBar;
